import React from 'react'
import { useTranslation } from 'react-i18next'
import { Search } from 'lucide-react'

interface SearchBarSectionProps {
  searchQuery: string
  onSearchChange: (query: string) => void
  placeholder?: string
  isRTL?: boolean
  className?: string
}

const SearchBarSection: React.FC<SearchBarSectionProps> = ({
  searchQuery,
  onSearchChange,
  placeholder,
  isRTL,
  className = '',
}) => {
  const { t, i18n } = useTranslation()
  const computedRTL =
    typeof isRTL === 'boolean'
      ? isRTL
      : (typeof document !== 'undefined' && document.documentElement?.dir === 'rtl') ||
        (typeof i18n.dir === 'function' && i18n.dir() === 'rtl')

  return (
    <div
      className={`h-[40px] bg-white rounded-xl px-4  flex items-center gap-1  ${className}`}
    >

      {/* Search icon: right in RTL, left in LTR */}
      <div
        className={`w-6 h-6 flex items-center justify-center `}
      >
        <Search className="w-9 h-8 text-[#525866] " />
      </div>
      <input
  type="text"
  className={`no-focus flex-1 text-sm text-[#2f3134] bg-transparent border-0 ${
    computedRTL ? 'text-right' : 'text-left'
  }`}
  placeholder={placeholder || t('home.search_placeholder')}
  value={searchQuery}
  onChange={(e) => onSearchChange(e.target.value)}
  dir={computedRTL ? 'rtl' : 'ltr'}

/>


      {/* End spacer handled above */}
    </div>
  )
}

export default SearchBarSection

